export const FILE_TYPES = {
  CSV: {
    EXTENSION: ['csv'],
    MIME_TYPES: ['text/csv', 'application/octet-stream', 'application/vnd.ms-excel'],
    ILLUSTRATION: 'csv',
  },
  PDF: {
    EXTENSION: ['pdf'],
    MIME_TYPES: ['application/pdf'],
    ILLUSTRATION: 'pdf',
  },
  PNG: {
    EXTENSION: ['png'],
    MIME_TYPES: ['image/png'],
    ILLUSTRATION: 'image',
  },
  JPEG: {
    EXTENSION: ['jpg', 'jpeg'],
    MIME_TYPES: ['image/jpeg'],
    ILLUSTRATION: 'image',
  },
  DOC: {
    EXTENSION: ['doc', 'docx'],
    MIME_TYPES: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ILLUSTRATION: 'document',
  },
  XLS: {
    EXTENSION: ['xls', 'xlsx'],
    MIME_TYPES: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ILLUSTRATION: 'csv',
  },
};

export enum FileUploadSizes {
  Dense = 'dense',
  Standard = 'standard',
}

export type FileUploadSize = `${FileUploadSizes}`;
